const paramMapping = {
    screen: {
        payload: {
            screenId: 'pg_name',
        },
    },
    ad_clicks: {
        payload: {
            advertisementId: 'wa_aid_lnk',
            advertisementMidasId: 'midas_id',
            // The two below make up jp_aid_p. It is pageId/placementId
            advertisementPageId: 'jp_aid_p',
            advertisementPlacementId: 'jp_aid_p',
            variations: 'jp_aid_c',
        },
    },
    ad_impressions: {
        payload: {
            // Could also use adClick and just overwrite the below value
            advertisementId: 'wa_aid_i',
            advertisementMidasId: 'midas_id',
            // The two below make up jp_aid_p. It is pageId/placementId
            advertisementPageId: 'jp_aid_p',
            advertisementPlacementId: 'jp_aid_p',
            variations: 'jp_aid_c',
        },
    },
    form_field: {
        payload: {
            referrerUrl: 'rf',
            formName: 'wa_frm_n',
            formStep: 'wa_frm_s',
        },
    },
    internal_video: {
        payload: {
            videoId: 'eid',
            videoName: 'wa_fl_n',
            videoAction: 'wa_fl_a',
            videoTitle: 'pt',
        },
    },
    external_video: {
        payload: {
            lineOfBusiness: 'wa_lob',
            videoName: 'wa_vi_n',
            videoStep: 'wa_vi_s',
            videoType: 'wa_vi_tp',
            videoTitle: 'wa_pt',
        },
    },
    dynamic_links: {
        payload: {
            linkUrl: 'wa_lu',
            linkName: 'wa_lnk',
        },
    },
    scroll: {
        payload: {
            scrollDepth: 'jp_scdp',
            scrollDirection: 'jp_scdr',
            scrollComponent: 'jp_scco',
            scrollComponentPlacement: 'jp_sccp',
            scrollRootPage: 'url',
            scrollCategory: 'pt',
        },
    },
    hover: {
        payload: {
            hoverName: 'wa_hov_n',
            hoverDescription: 'wa_hov_d',
        },
    },
    document_links: {
        payload: {
            documentName: 'wa_dcdl',
            documentUrl: 'wa_lu',
        },
    },
    exit_links: {
        payload: {
            exitLink: 'wa_exlnk',
            exitUrl: 'wa_lu',
        },
    },
    tab: {
        payload: {
            tabName: 'wa_tab_n',
            tabDescription: 'wa_tab_d',
        },
    },
    personalization_impression: {
        payload: {
            elementName: 'jp_peid',
            elementPlacement: 'jp_pepl',
            product: 'jp_pepr',
            category: 'jp_pepc',
            elementContext: 'jp_pecv',
        },
    },
    personalization_interaction: {
        payload: {
            elementName: 'jp_peid',
            elementPlacement: 'jp_pepl',
            product: 'jp_pepr',
            category: 'jp_pepc',
            elementContext: 'jp_pecv',
        },
    },
    personalization_click: {
        payload: {
            elementName: 'jp_peid',
            elementPlacement: 'jp_pepl',
            product: 'jp_pepr',
            category: 'jp_pepc',
            elementContext: 'jp_pecv',
        },
    },
    modal: {
        payload: {
            modalName: 'wa_dyn_n',
            modalDescription: 'wa_dyn_d',
        },
    },
};
export default paramMapping;
//# sourceMappingURL=paramMapping.js.map